import script from "./AppWrapper.vue?vue&type=script&setup=true&lang=js"
export * from "./AppWrapper.vue?vue&type=script&setup=true&lang=js"

import "./AppWrapper.vue?vue&type=style&index=0&id=375ad872&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-375ad872"]])

export default __exports__